import { render } from "./FleetCreate.vue?vue&type=template&id=450aeb27"
import script from "./FleetCreate.vue?vue&type=script&lang=js"
export * from "./FleetCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__